import Request from './request'
const CRM_BASE_URL = process.env.NODE_ENV === 'production' ? '' : '/crmapi'

export const getAndroidApk = async requestData => {
  return await Request({
    title: '获取最新版本包',
    url: CRM_BASE_URL + '/api/b/version/newestApp',
    data: requestData
  })
}

export const getLogisticsDetail = async requestData => {
  return await Request({
    title: '获取订单物流详情',
    url: CRM_BASE_URL + '/api/b/logistics/detail',
    data: requestData
  })
}

export const approveListBybusinessId = async requestData => {
  return await Request({
    title: '获取审批流程',
    url: CRM_BASE_URL + '/api/b/approve/listBybusinessId',
    data: requestData
  })
}

// v2.1.3新增-员工备件申请审批流程
export const recordListByBusinessId = async requestData => {
  return await Request({
    title: '获取审批流程',
    url: CRM_BASE_URL + '/api/b/approve/recordListByBusinessId',
    data: requestData
  })
}

export const getSaleProcess = async requestData => {
  return await Request({
    title: '获取采购订单流程/销售订单流程/生态订单流程',
    url: CRM_BASE_URL + '/api/b/order/platform/getSaleProcess',
    data: requestData
  })
}

export const getExchangeProcess = async requestData => {
  return await Request({
    title: '获取换货订单流程',
    url: CRM_BASE_URL + '/api/b/aftersales/platform/exchangeOrder/getProcess',
    data: requestData
  })
}

export const getReturnProcess = async requestData => {
  return await Request({
    title: '获取退货订单流程',
    url: CRM_BASE_URL + '/api/b/aftersales/platform/refundOrder/getProcess',
    data: requestData
  })
}

export const getafterSalesSchedule = async requestData => {
  return await Request({
    title: '获取售后产品库-售后进度',
    url: CRM_BASE_URL + '/api/b/aftersales/platform/productSn/schedule',
    data: requestData
  })
}

export const getNoticeDetail = async requestData => {
  return await Request({
    title: '获取公共详情',
    url: CRM_BASE_URL + '/api/b/notice/query',
    method: 'post',
    data: requestData
  })
}

export const setCrmDicRoutes = async requestData => {
  return await Request({
    title: '更新crm平台路由字典配置',
    method: 'post',
    url: '/api/system/dict/data/batchInitDictData',
    headers: {
      'Content-Type': 'application/json'
    },
    data: requestData
  })
}

export const getApplyPolicyProtocol = async requestData => {
  return await Request({
    title: 'APP获取用户协议和隐私政策',
    url: CRM_BASE_URL + '/api/b/version/getApplyPolicyProtocol',
    data: requestData
  })
}
